export const APS_REVIEW_READY_EVENT = "abc-aps-review-ready";
export const APS_REVIEW_OPEN_EVENT = "abc-aps-review-open";
export const APS_REVIEW_SEEN_EVENT = "abc-aps-review-seen";

export function emitApsReviewReady(detail) {
  window.dispatchEvent(new CustomEvent(APS_REVIEW_READY_EVENT, { detail }));
}

export function emitApsReviewOpen(detail) {
  window.dispatchEvent(new CustomEvent(APS_REVIEW_OPEN_EVENT, { detail }));
}

export function emitApsReviewSeen(detail) {
  window.dispatchEvent(new CustomEvent(APS_REVIEW_SEEN_EVENT, { detail }));
}
